'use client'

import { Accordion, AccordionItem } from '@heroui/react'
import { Faq } from '../../types/model/faq.model'

export default function Faqs({ faqs }: { faqs: Faq[] }) {
  return (
    <Accordion
      selectionMode='single'
      itemClasses={{
        base: 'px-4 py-0.5 data-[open=true]:bg-white transition-colors duration-200',
        title:
          'text-mountain-bluebird font-medium text-lg sm:max-w-[275px] max-w-full',
        content: 'text-mountain-bluebird text-base leading-relaxed py-1',
        indicator: 'text-creamed-cron',
        trigger: 'py-3 cursor-pointer',
      }}
      motionProps={{
        variants: {
          enter: {
            opacity: 1,
            height: 'auto',
            transition: { duration: 0.25 },
          },
          exit: {
            opacity: 0,
            height: 0,
            transition: { duration: 0.2 },
          },
        },
      }}
    >
      {faqs.map((faq, index) => (
        <AccordionItem
          key={index}
          aria-label={faq.question}
          title={<div dangerouslySetInnerHTML={{ __html: faq.question }}></div>}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: faq.answer,
            }}
          />
        </AccordionItem>
      ))}
    </Accordion>
  )
}
